import { HttpClient } from '@angular/common/http';
import { computed, inject, Injectable, signal } from '@angular/core';
import { tap } from 'rxjs';
import { CreatePackDTO, Pack, PackOptions } from 'src/app/shared/model/pack';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class PackService {
  http = inject(HttpClient);
  readonly adminUrl = `${environment.apiUrl}/admin/packs`;
  private packList = signal<Pack[] | null>(null);
  private loading = false;
  packs = computed(() => {
    const value = this.packList();
    if (!value && !this.loading) {
      this.loading = true;
      this.getPacks().subscribe({
        next: (list) => {
          this.packList.set(list);
          this.loading = false;
        },
        error: () => {
          this.loading = false;
        },
      });
    }
    return value;
  });

  public getPacks() {
    return this.http.get<Pack[]>(this.adminUrl);
  }
  public getPackById(id: string) {
    return this.http.get<Pack>(`${this.adminUrl}/${id}`);
  }
  public createPack(data: CreatePackDTO) {
    return this.http.post<Pack>(this.adminUrl, data).pipe(
      tap((newPack) => {
        this.packList.update((list) => [...(list ?? []), newPack]);
      }),
    );
  }
  public updatePack(data: CreatePackDTO, id: string) {
    return this.http.put<Pack>(`${this.adminUrl}/${id}`, data).pipe(
      tap((updatedPack) => {
        this.packList.update((list) =>
          (list ?? []).map((pack) =>
            pack.id === updatedPack.id ? updatedPack : pack,
          ),
        );
      }),
    );
  }
  public deletePack(id: string) {
    return this.http
      .delete<{ message: string; id: string }>(`${this.adminUrl}/${id}`)
      .pipe(
        tap((res) => {
          this.packList.update((list) =>
            (list ?? []).filter((pack) => pack.id !== res.id),
          );
        }),
      );
  }
  public updateCompanyPack(
    packId: string,
    overrides: PackOptions,
    companyId: string,
  ) {
    return this.http.put<Pack>(`${this.adminUrl}/company/${companyId}`, {
      packId,
      overrides,
    });
  }
}
